import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import LeCamping from "@/components/LeCamping";
import Galerie from "@/components/Galerie";
import Hebergements from "@/components/Hebergements";
import Piscine from "@/components/Piscine";
import Services from "@/components/Services";
import Avis from "@/components/Avis";
import Region from "@/components/Region";
import Faq from "@/components/Faq";
import Reservation from "@/components/Reservation";

export default function HomePage({ scrollTo }) {
  return (
    <main>
      <Hero scrollTo={scrollTo} />
      <MarqueeStrip />
      <LeCamping />
      <Galerie />
      <Hebergements />
      <Piscine />
      <Services />
      <Avis />
      <Region />
      <Faq />
      <Reservation />
    </main>
  );
}
